define('gameday-language/languages/es',{

        "ball"      : "bola",
        "balls"     : "bolas",
        "pitch"     : "pitcheo",
        "pitches"   : "pitcheos",
        "batting"   : "bateo",
        "hitting"   : "bateo",
        "pitching"  : "pitching",

        "Pitch"     : "Lanzamiento",
        "Pitches"   : "Lanzamientos",
        "Batting"   : "Bateo",
        "batting"   : "bateo",
        "Hitting"   : "Bateo",
        "Pitching"  : "Pitcheo",
        "pitching"  : "pitcheo",
        "Pitching Substitution"  : "Cambio de lanzador",
        "Pitcher"   : "Lanzador",
        "Scoring Plays" : "Anotaciones",
        "Scoring"   : "Anotaciones",
        "Recent Plays" : "Jagadas Recientes",
        "All Plays" : "Paso por Paso",
        "On deck"   : "Círculo de bateo",
        "deck"      : "CB",
        "In the hole" : "Siguiente bateador",
        // "P"         : "L",
        "hole"      : "SB",
        "Highlights": "Momentos destacados",
        "In-Game Highlights": "Momentos destacados",
        "Highlight": "Momento destacado",
        "On Base"   : "En Base",
        "Now Viewing": "Viendo Ahora",
        "{{1}} Recap"     : "{{1}} Resumen",
        // "AB"        : "TB",


    // Pitches
        "Changeup" : "Cambio de velocidad",
        "Curveball" : "Curva",
        "Fastball" : "Bola rápida",
        "Two-Seam Fastball" : "Bola rápida de dos costuras",
        "Four-Seam Fastball" : "Bola rápida de cuatro costuras",
        "Cutter" : "Recta cortada",
        "Splitter" : "Splitter",
        "Forkball" : "Bola de tenedor",
        "Gyroball" : "Gyroball",
        "Int. Ball" : "Bola int",
        "Knuckle Curve" : "Bola de nudillos con curva",
        "Knuckleball" : "Bola de nudillos",
        "No Pitch" : "No hay lanzamiento",
        "Screwball" : "Tirabuzón",
        "Sinker" : "Sinker",
        "Slider" : "Slider",
        "Unknown" : "Desconocido",
        "Pitchout" : "Lanzamiento abierto",
        "Auto. Ball" : "Bola automática",
        "Auto. Strike" : "Strike automática",
        "Eephus" : "Lanzamiento lento",

    // tabs and abstract states
        "Box"       : "Num.",
        "Plays"     : "Jugadas",
        "Play"      : "Jugada",
        "Videos"    : "Videos",
        "Field"     : "Campo",
        "Color"     : "Color",

        "Wrapup"    : "Resumen",
        "Game Over" : "Final",
        "Live"      : "En Vivo",
        "In Progress"   : "En Vivo",
        "Warmup"        : "Calentamiento",
        "Pregame"       : "Alineación",
        "Preview"       : "Previo",
        "Final"         : "Final",
        "Delayed"       : "Retrasado",
        "Del"           : "Ret",
        "Delayed Start" : "Inicio Retrasado",
        "Suspended"     : "Suspendido",
        "Susp"          : "Susp",
        "Forfeit"       : "Forfiet",
        "Cancel"        : "Cancel",
        "Cancelled"      : "Cancelado",
        "Replay"        : "Repetición instantánea",
        "Review"    : "Revisi&#243;n",
        "Postponed" : "Pospuesto",
        "Ceremony"  : "Ceremonia",
        "Rain"      : "Lluvias",
        "No-hitter" : "Sin hit",
        "Perfect game" : "Juego perfecto",

    // dates 
        //  Date format switch... might be a bad idea
        "{{1}}, {{2}} {{3}}, {{4}}" : "{{1}}, {{3}} de {{2}}, {{4}}",
        "March": "marzo",
        "Mar": "marzo",
        "April": "abril",
        "Apr": "abr",
        "May": "mayo",
        "June": "junio",
        "July": "julio",
        "August": "agosto",
        "Aug": "ago",
        "September": "septiembre",
        "Sep": "sep",
        "October": "octubre",
        "Oct": "oct",
        "Monday": "lunes",
        "Tuesday": "martes",
        "Wednesday": "mi&#233;rcoles",
        "Thursday": "jueves",
        "Friday": "viernes",
        "Saturday": "s&#225;bado",
        "Sunday": "domingo",
        "Mon": "lun",
        "Tue": "mar",
        "Tues": "mar",
        "Wed": "mi&#233;",
        "Thu": "jue",
        "Thurs": "jue",
        "Fri": "vie",
        "Sat": "s&#225;b",
        "Sun": "som",        
        "Today" : "Hoy",
        "Today's" : "de Hoy",

    // scores
        "win": "ganan",
        "tied": "empatado",
        "lead": "lidera",        
        "win": "ganan",
        "tied": "empatado",
        "lead": "lidera",        
        // "W": "G",
        // "L": "P",
        // "W-L" : "G-P",

    // Right/Left
        "L" : "Z",
        "R" : "D",

    // League
        "NL Champion": "Campe&#243;n LN",
        "AL Champion": "Campe&#243;n LA",
        "AL Lower Seed": "Clasificaci&#243;n Baja LA",
        "NL Lower Seed": "Clasificaci&#243;n Baja LN",
        "AL Higher Seed": "Clasificaci&#243;n Alta LA",
        "NL Higher Seed": "Clasificaci&#243;n Alta LN",
        "NLDS": "SDLN",
        "ALDS": "SDLA",
        "ALCS": "SCLA",
        "NLCS": "SCLN",
        "ALWC": "WCLA",
        "NLWC": "WCLN",
        "Gm": "Jgo",

    // ordinals
        "1st": "1ra",
        "2nd": "2da",
        "3rd": "3ra",
        "4th": "4ta",
        "5th": "5ta",
        "6th": "6ta",
        "7th": "7ma",
        "8th": "8va",
        "9th": "9na",
        "10th": "10ma",
        "11th": "11mo",
        "12th": "12ma",
        "13th": "13to",
        "14th": "14to",
        "15th": "15to",
        "16th": "16to",
        "17th": "17to",
        "18th": "18to",
        "19th": "19to",
        "20th": "20to",
        "21st": "21to",
        "22nd": "22to",
        "23rd": "23to",
        "24th": "24to",
        "25th": "25to",
        "26th": "26to",
        "27th": "27to",
        "28th": "28to",
        "29th": "29to",
        "30th": "30to",

    // Relations
        "Timeframe": "Periodo",
        "Pre All-Star": "Antes del ASG",
        "Post All-Star": "Despu&#233;s del ASG",
        "Day": "D&#237;a",
        "Today's Game": "el Juego de Hoy",
        "On Mondays": "los lunes",
        "On Tuesdays": "los martes",
        "On Wednesdays": "los mi&#233;rcoles",
        "On Thursdays": "los jueves",
        "On Fridays": "los viernes",
        "On Saturdays": "los s&#225;bado",
        "On Sundays": "los domingos",
        "Opponent": "adversario",
        "vs. AL": "vs LA",
        "vs. NL": "vs LN",
        "At-Bat": "Turnos al bate",
        "Batting Left": "Bateando izquierdo",
        "Batting Right": "Bateando derecho",
        "vs Left": "vs zurdo",
        "vs Right": "vs derecho",
        "Score": "Pizarra",
        "Team is ahead": "Equipo ganando",
        "Team is behind": "Equipo perdiendo",
        "Score is tied": "Marcador empatado",
        "Late / Close": "Tarde/Cercano",
        "Result": "Resultado",
        "In games won by team": "En juegos ganados por el equipo",
        "In games lost by team": "En juegos perdidos por el equipo",
        "In games following a win": "En juegos posteriores a una victoria",
        "In games following a loss": "En juegos posteriores a una derrota",
        "Order": "Orden",
        "Batting First": "Bateando primero",
        "Batting Second": "Bateando segundo",
        "Batting Third": "Bateando tercero",
        "Batting Fourth": "Bateando cuarto",
        "Batting Fifth": "Bateando quinto",
        "Batting Sixth": "Bateando sexto",
        "Batting Seventh": "Bateando s&#233;ptimo",
        "Batting Eighth": "Bateando octavo",
        "Batting Ninth": "Bateando noveno",
        "Position": "Posici&#243;n",
        "Pitcher": "Lanzador",
        "Catcher": "Receptor",
        "First Base": "Primera base",
        "Second Base": "Segunda base",
        "Third Base": "Tercera base",
        "Shortstop": "Campocorto",
        "Left Field": "Jard&#237;n izquierdo",
        "Center Field": "Jard&#237;n central",
        "Right Field": "Jard&#237;n derecho",
        "Designated Hitter": "Bateador designado",
        "Pinch Hitter": "Bateador suplente",
        "Pinch Runner": "Corredor suplente",
        "Inning": "Entrada",
        "First Inning": "Primera entrada",
        "Second Inning": "Segunda entrada",
        "Third Inning": "Tercera entrada",
        "Fourth Inning": "Cuerta entrada",
        "Fifth Inning": "Quinta entrada",
        "Sixth Inning": "Sexta entrada",
        "Seventh Inning": "S&#233;ptima entrada ",
        "Eighth Inning": "Octava entrada",
        "Ninth Inning": "Novena entrada",
        "Extra Innings": "Extra entradas",
        "Innings One to Six": "Entradas de la primera a la sexta",
        "Seventh or Later": "S&#233;ptima entrada en adelante",
        "Eighth or Later": "Octava entrada en adelante",
        "Ninth or Later": "Novena entrada en adelante",
        "Runners": "Corredores",
        "Leading Off": "Empezando inning",
        "Empty (Not Leadoff)": "Bases vac&#237;as (sin empezar inning)",
        "Bases Empty": "Bases vacias",
        "Bases Loaded": "Bases llenas",
        "Runner at 1st": "Corredor en primera",
        "Runners at 1st & 2nd": "Corredores en 1ra y 2da",
        "Runners at 1st & 3rd": "Corredores en 1ra y 3ra",
        "Runner at 2nd": "Corredor en 2da",
        "Runners at 2nd & 3rd": "Corredores en 2da y 3ra",
        "Runner at 3rd": "Corredor en 3ra",
        "Runners On": "Corredores en base",
        "Runners On - 2 Outs": "Corredores en base - 2 outs",
        "Scoring Position": "Posici&#243;n de anotar",
        "Scoring Position - 2 Outs": "Posici&#243;n de anotar - 2 outs",
        "3rd, Less than 2 Outs": "3ra, menos de 2 outs",
        "Outs": "Outs",
        "No Outs": "Sin outs",
        "One Out": "Un out",
        "Two Outs": "Dos outs",
        "Count": "Cuenta",
        "First Pitch": "Primer lanzamiento",
        "Ahead in Count": "Arriba en el conteo",
        "Behind in Count": "Abajo en el conteo",
        "Even Count": "Conteo igualado",
        "Two Strikes": "Dos strikes",
        "Full Count": "Cuenta llena",
        "Unknown or no Count": "Sin conteo o con conteo desconocido",
        "0-0 Count": "Cuenta 0-0",
        "0-1 Count": "Cuenta 0-1",
        "0-2 Count": "Cuenta 0-2",
        "1-0 Count": "Cuenta 1-0",
        "1-1 Count": "Cuenta 1-1",
        "1-2 Count": "Cuenta 1-2",
        "2-0 Count": "Cuenta 2-0",
        "2-1 Count": "Cuenta 2-1",
        "2-2 Count": "Cuenta 2-2",
        "3-0 Count": "Cuenta 3-0",
        "3-1 Count": "Cuenta 3-1",
        "3-2 Count": "Cuenta 3-2",

    // stats
        "Ball: {{1}} Strike: {{2}} Out: {{3}}" : "Bola: {{1}} Strike: {{2}} Out: {{3}}",

        "Home Games": "Juego en Casa",
        "Away Games": "Juego Visitante",
        "Day Games": "Juego de d&#237;a",
        "Night Games": "Juego de noche",
        "On Grass": "Grama natural",
        "On Turf": "Grama artificial",

        "Team"   : "Equipo",
        "At Bats": "Turnos al bate",
        // "AVG": "PRO",
        "Average": "Promedio",
        "Batting Average": "Promedio de bateo",
        "CS": "AR",
        "Caught Stealing": "Atrapado robando",
        "GDP": "RDP",
        "Double Plays": "Doble matanza",
        "Ground into Double Plays": "Batazos de doble matanza",
        "2B": "2B",
        "Doubles": "Dobles",
        "Double": "Doble",
        "XBH": "Extbs.",
        "Extra Base Hits": "Hits extrabases",
        "AO": "Ele.",
        "Fly Outs": "Ele.",
        "G": "J",
        "Game": "Juego",
        "Games": "Juegos",
        "Games Played": "Juegos jugados",
        "GO": "Rol.",
        "Ground Outs": "Roletazos",
        "GO/AO": "Rol./Ele.",
        "Ground/Fly Outs": "Roletazo/Elevado",
        "Ground Outs/Fly Outs": "Roletazos/Elevados",
        "HBP": "GPP",
        "Hit by Pitch": "Golpeado por la pelota",
        // "H": "H",
        "Hits": "Hits",
        "HR": "H4",
        "Home Runs": "Jonr&#243;n",
        "IBB": "BBI",
        "Intentional Walks": "Pases intencional",
        "NP": "NP",
        "Number of Pitches": "Numero de pitcheos",
        "OBP": "OBP",
        "On-base %": "% de embasarse",
        "On-base Percentage": "Promedio de embasarse",
        "OPS": "OPS",
        "On-base Plus Slugging Percentage": "Promedio de embase m&#225;s slugging",
        "PA": "VB",
        "Plate Appearances": "Turnos al bate",
        "Total Plate Appearances": "Total de turnos al bate",
        "RBI": "CI",
        "Runs Batted In": "Carrera impulsada",
        // ""R"": "C",
        "Runs": "Carreras",
        "Runs Scored": "Carreras anotadas",
        "SAC": "SAC",
        "Sacrifice Bunts": "Toque de sacrificio",
        "SF": "SF",
        "Sacrifice Flies": "Flies de sacrificio",
        "SLG": "SLG",
        "Slugging %": "% Slugging",
        "Slugging Percentage": "Promedio de slugging",
        "SB": "BR",
        "Stolen Bases": "Bases robadas",
        "SO": "SO",
        "Strikeouts": "Ponches",
        "Strikeout": "Ponche",
        "strikes out": "poncha",
        "singles off": "conecta sencillo frente",
        "doubles off": "conecta doble frente",
        "triples off": "conecta triple frente",
        "homers off": "conecta jonrón frente",
        "TB": "TB",
        "Total Bases": "Total de bases",
        "3B": "3B",
        "Triples": "Triples",
        "Triple": "Triple",
        "BB": "BB",
        "Walks": "Boletos",
        "Walk": "Boleto",
        "Bases on Balls (Walks)": "Base por bolas",
        "vs. Batter": "vs. bateadores",
        "Starter": "Abridor",
        "Reliever": "Relevista",

        "BK": "BK",
        "Balks": "Balks",
        "TBF": "Bateadores enfrentados",
        "Batters Faced": "Bateadores enfrentados",
        "Total Batters Faced": "Total de bateadores enfrentados",
        "CG": "JC",
        "Complete Games": "Juegos completos",
        "GIDP": "RDP",
        "Grounded Into Double Plays": "Roletazos para doble matanza",
        "ER": "CL",
        "Earned Runs": "Carreras limpias",
        // "ERA": "ERA",
        "Earned Run Average": "Promedio de carreras limpias",
        "GF": "JT",
        "Game Finished": "Juegos Terminados",
        "Ground Outs/ Fly Outs Ratio": "Proporci&#243;n de roletazos/elevados",
        "HB": "GP",
        "Hit Batsmen": "Golpeados",
        "H/9": "H/9",
        "Hits/9": "Hits/9",
        "Hits per Nine Innings": "Hits por nueve entradas",
        "HLD": "VP",
        "Holds": "Ventajas Preservadas",
        "Hold": "Ventaja Preservada",
        "IP": "IL",
        "Innings": "Entradas",
        "Innings Pitched": "Entradas lanzadas",
        // "L": "P",
        "Losses": "Derrotas",
        "Opp. AVG": "AVG Oponente",
        "Opponents Batting Average": "Promedio de bateo - oposici&oacute;n",
        "PK": "V",
        "Pick-offs": "Atrapados en Viraje",
        "Pitches Thrown": "Lanzamientos",
        "Number of Pitches Thrown": "Cantidad de Lanzamientos",
        "P/IP": "P/IL",
        "Pitches/9": "Lanzamientos/9",
        "Pitches per Innings Pitched": "Lanzamientos por entrada",
        "SVO": "OSV",
        "Save Opportunities": "Oportunidades de salvamento",
        "SV": "SV",
        "Saves": "Salvados",
        "SHO": "BL",
        "Shutouts": "Blanqueadas",
        "Slugging Percentage Allowed": "Porcentaje de slugging permitido",
        "GS": "Aperturas",
        "Starts": "AP",
        "Games Started": "Juegos iniciados",
        "K/BB": "K/BB",
        "Strikeout/Walk": "Ponches/bases por bolas",
        "Strikeout/Walk Ratio": "Ponches/Bases por bolas",
        "K/9": "K/9",
        "Strikeouts/9": "Ponches/9",
        "Strikeouts per Nine Innings": "Ponches por cada nueve entradas",
        "Bases on Balls (Walks) Allowed": "Bases por bolas permitidas",
        "BB/9": "BB/9",
        "Walks/9": "Bases por Bolas/9",
        "Walks per Nine Innings": "Bases por Bolas por cada nueve innings",
        "WHIP": "WHIP",
        "Walks + Hits/Innings Pitched": "Bases por Bolas + Hits/Entradas lanzadas",
        "WP": "WP",
        "Wild Pitches": "Lanzamientos Desviados",
        "WPCT": "WPCT",
        "Winning %": "% de Ganados",
        "Winning Percentage": "Porcentaje de Ganados",
        // "W": "G",
        "Wins": "Ganados",
        "Assists": "Asistencias",
        "Errors": "Errores",
        "Fielding %": "% de Fildeo",
        "Fielding Percentage": "Porcentaje de Fildeo",
        "Innings Played": "Entradas jugadas",
        "Passed Balls": "Passed Balls",
        "PO": "Outs",
        "Putouts": "Outs",
        "RF": "FA",
        "Range Factor": "Factor de Alcance",
        "SBPCT": "% BR",
        "Stolen Base %": "% de Bases Robadas",
        "Stolen Base Percentage": "Porcentaje de bases robadas",
        "Stolen Bases (allowed)": "Bases robadas (permitidas)",
        "TC": "OT",
        "Total Chances": "Total de Oportunidades",
        "CWP": "CWP",
        "Catcher WP": "WP del Catcher",
        "Catcher Wild Pitches": "Lanzamientos Desviados",
        "All MLB": "Todo MLB",
        "All Pos.": "Todas Pos.",
        "Splits": "Divididas",
        "Fielding": "Fildeo",
        "Totals" : "Totales",
        "Recent Seasons" : "Temporada Recientes",

        "Expand Scoreboard": "Expandir Resultados",
          "Collapse Scoreboard": "Contraer Resultados",
          "Latest News": "Noticias recientes",
          "More News": "M&#225;s Noticias",
          "minute ago": "minuto pas&#243;",
          "minutes ago": "minutos pasaron",
          "hour ago": "hora paso",
          "hours ago": "horas pasaron",
          "Full Standings": "Posiciones completas",
          "More Stats"  : "M&#225;s Estad&#237;sticas",
          "Sortable Stats": "Estad&#237;sticas Clasificadas",
          "All Times": "Todos los horarios",
          "Subject To Change": "Sujeto a cambio",
          "Tickets": "Boletos",
          "Buy Tickets": "Compra Boletos",
          "Promotions" : "Promociones",
          "Matchup": "Enfrentamiento",
          "Time/Status": "Horario/estado",
          "Away Probable": "Lanzador visitante",
          "Home Probable": "Lanzador local",
          "Time": "Horario",
          "Winning Pitcher": "Lanzador Ganador",
          "Losing Pitcher": "Lanzador Perdedor",
          "Stats": "Estad&#237;sticas",
          // "Stats ": "Est.",
          "Summary": "Res.",
          "Last 3 Seasons": "Ultimas 3 Temporadas",
          "Last 10 Games": "Ultimos 10 Juegos",
          "Last 5 Years"    : "Ultimas 5 A&#241;o",
          "Career": "Carrera",
          "Bats": "Batea",
          "Throws": "Tira",
          "Born": "Nacido",
          "All": "Todas",
          "Season": "Temporada",
          "Game Logs": "Juego por Juego",
          "Media": "Medios",
          "Age": "Edad",
          "yrs": "a&#241;os",
          "Top": "Alta",
          "Bot": "Baja",
          "Bottom": "Baja",
          "Mid": "Media",
          "Middle": "Media",
          "End": "Fin",
          "Year": "A&#241;o",
          "Date": "Fecha",
          "Opp": "Opo",
          "Ppd": "Posp",
          "Player News": "Noticias del jugador",
          "Player Highlights": "Video del jugador",
          "Player Stats" : "Estadísticas del Jugador",
          "Player Card" :  "Tarjetas de Jugador",
          "{{1}} Stats" : "Estadísticas {{1}}",
          "Level": "Nivel",
          "Minors": "Menores",
          "Split": "Stats Divididas",
          "Search Players and Teams": "Buscar Jugadores y Equipos",
          "Next Month": "Pr—ximo mes",
          "Last Month": "Mes Pasado",
          "List": "Lista",
          "Monthly": "Mensual",
          "Presented by": "Presentado por",
          "The": "Los",
          "Loves to Face" : "Ama a Enfrentar",
          "Hates to Face" : "Ama a Enfrentar",

    //Season
        "Spring": "Primavera",
        "Spring Training": "Entrenamiento Primaveral",
        "Reg. Season": "Temporada Reg.",
        "Regular Season": "Temporada Regular",
        "Postseason": "Postemporada",
        "Wild Card": "Comodín",
        "-Wild Card": "-Comodín",
        "DS": "SD",
        "Division Series": "Series Divisionales",
        "-Division Series": "-Series Divisionales",
        "LCS": "SCL",
        "-LCS": "-SCL",
        "League Championship Series": "Series de Campeonato",
        "WS": "SM",
        "World Series": "Serie Mundial",
        "-World Series": "-Serie Mundial",
        "All Star Game" : "Juego de Estrellas",
        


        //other
        "TBD"       : "SD",
        "of"        : "de",
        "of the"    : "del",
        "Available" : "disponibles",
        "on a pitch with a nasty factor of" : "en un pitcheo con factor veneno de",
        "Due up": "Por batear",
        "Lineout" : "Línea de Out",
        "Manager Review" : "Revisión del Mánager",
        "Runner Out" : "Corredor Retirado",
        "Pop Out" : "Elevado de Out",  
        "Bunt Groundouts" : "Rodadas de Out en Toque de Bola",  
        "Flyout" : "Elevado de Out",  
        "Groundout" : "Rodada de Out",  
        "Single" : "Sencillo",  
        "Defensive Sub" : "Sustitución Defensiva",  
        "Forceout" : "Out Forzado",
        "Pickoff 1B" : "Out en Viraje a 1B",
        "RHP"   : "LD",
        "LHP"   : "LZ",
        "Lineup Information" : "Información del Lineup",
        "The game feed will begin shortly" : "La fuente de juego se iniciará en breve",
        "In-Game Highlight" : "Momentos destacados",
        "Continue" : "Continuar",
        "Close" : "Ok",
        "Inning Break" : "Entre entradas"
        
});

